<template>
  <div class="pfol__history">
    <HKLLeftRight
      v-for="(item, index) in completedPostFitouts"
      :key="index"
      class="pfol__history-item align-middle"
    >
      <div
        class="pfol__history-title"
        @click="() => previewHistory(item)"
      >
        {{ $t('tenantProjects.postFitout.title') }} {{ item.number }}
      </div>
      <HKLGrayHint>
        {{ item.TipWording }}
      </HKLGrayHint>
    </HKLLeftRight>
    <PostFitOutPreviewSendModal
      ref="previewSendModal"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { computed } from '@vue/composition-api'
import { getCurrentInstance, inject } from 'vue-demi'
import HKLLeftRight from '@/controls/Layout/HKLLeftRight'
import HKLGrayHint from '@/controls/HKLGrayHint'
import { POST_FITOUT_STATUS, PF_HISTORY_ACTION_TYPE } from './consts'
import { useStoreState } from '@/store'
import dateUtil from '@/utils/dateUtil'
import PostFitOutPreviewSendModal from './PostFitOutPreviewSendModal'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { DEPENDENCY_KEYS } from '../consts'

export default {
  components: {
    HKLLeftRight,
    HKLGrayHint,
    PostFitOutPreviewSendModal,
  },
  setup () {
    const state = useStoreState()
    const { proxy } = getCurrentInstance()

    const completedPostFitouts = computed(() => {
      const result = _.get(state.value, 'postFitoutSubmission.postFitouts').filter(item => item.status === POST_FITOUT_STATUS.COMPLETED)
      return _.orderBy(result, ['createdAt'], ['desc']).map((item) => {
        return {
          ...item,
          number: item.order ? item.order + 1 : '',
          TipWording: setUpTipWording(item.histories),
        }
      })
    })
    const setUpTipWording = (histories) => {
      const latestHistory = _.orderBy(histories, 'createdAt', 'desc').filter(item => [PF_HISTORY_ACTION_TYPE.SEND, PF_HISTORY_ACTION_TYPE.RESEND].includes(item.actionType))[0] || {}
      const { displayName, actionTime } = getActionHistoryInfo(latestHistory)
      const tipWordingMaps = {
        [PF_HISTORY_ACTION_TYPE.SEND]: 'tenantProjects.submission.sentByOn',
        [PF_HISTORY_ACTION_TYPE.RESEND]: 'tenantProjects.submission.resentByOn',
      }
      return proxy.$t(tipWordingMaps[_.get(latestHistory, 'actionType')], [displayName, actionTime])
    }

    const getActionHistoryInfo = (history) => {
      const displayName = _.get(history, 'createdBy.displayName', proxy.$t('emptyValue'))
      const actionTime = dateUtil.formatDate(_.get(history, 'createdAt'), true)
      return { displayName, actionTime }
    }

    const previewSendModal = useRefModal()
    const currentSubmission = inject(DEPENDENCY_KEYS.CURRENT_SUBMISSION)

    const previewHistory = (item) => {
      currentSubmission.value = item
      previewSendModal.open()
    }

    return {
      completedPostFitouts,
      previewHistory,
      previewSendModal: previewSendModal.modal,

    }
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
.pfol__history-item {
  border: 1px solid #e0e1e4;
  color: #0c3a58;
  padding: 9px 14px 11px 17px;
  &:not(:last-child) {
    margin-bottom: 10px;
  }
  .hkl-gray-hint {
    font-size: 11px;
  }
}
.pfol__history-title {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
</style>
